<template>
    <div id="app">
        <Header></Header>
        <main class="myillini-student">
            <div class="container-fluid container-max">
                <router-view></router-view>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
    
    import Header from './components/Header.vue';
    import Footer from './components/Footer.vue';

    export default {
        name: 'app',
        components: {
            Header,
            Footer
        }
    };
</script>


<style lang="scss">
    @import "../public/css/sass/page-styles/myillini-dashboard-v2.scss";
</style>